import { gql, graphql } from "react-apollo"
import { GetSlidesQuery } from "./withSlides"
import type { Slide, SlideFormViewProps } from "../types"

const MUTATE_UPDATE_SLIDE = gql`
  mutation UpdateSlide($attractLoopId: ID!, $id: ID!, $slide: SlideInput!) {
    updateSlide(attractLoopId: $attractLoopId, id: $id, slide: $slide) {
      id
      title
    }
  }
`

const mutateUpdateSlide = graphql(MUTATE_UPDATE_SLIDE, {
  name: "mutateUpdateSlide",
  options: ({ attractLoopId }: SlideFormViewProps) => ({
    refetchQueries: [{ query: GetSlidesQuery, variables: { attractLoopId } }]
  }),
  props: ({ mutateUpdateSlide }) => ({
    updateSlide: (attractLoopId: string, id: string, slide: Slide) =>
      mutateUpdateSlide({
        variables: { attractLoopId, slide, id }
      })
  })
})

export default mutateUpdateSlide



// WEBPACK FOOTER //
// ./src/Slides/queries/mutateUpdateSlide.js